import { useEffect, useState } from "react";
import { workspacesService } from "features/workspaces/services/workspaces-service";
import type { ProjectResponse, IProjectId } from "features/projects/types";

export const useFetchProject = ({ projectId }: { projectId: IProjectId }): [ProjectResponse | undefined, boolean] => {
  const [project, setProject] = useState<ProjectResponse>();
  const [isFetching, setIsFetching] = useState<boolean>(false);

  useEffect(() => {
    const abortController = new AbortController();

    async function fetchData() {
      setIsFetching(true);

      try {
        const response = await workspacesService.getProject({ id: projectId }, abortController);
        setProject(response);
      } catch (error) {
        console.error(error);
      }

      setIsFetching(false);
    }

    fetchData();

    return () => {
      abortController.abort();
    };
  }, []);

  return [project, isFetching];
};
